import * as yup from 'yup';

const validarTipo = (valor, tipoFiltro) => {
  if (valor === '' || valor == null) return true;
  if (tipoFiltro === 'codigo') {
    return /^-?\d+$/.test(String(valor));
  }
  return String(valor).length <= 30;
};

const mensagemTipo = tipoFiltro =>
  tipoFiltro === 'codigo' ? 'Apenas números inteiros' : 'Máximo 30 caracteres';

export const filtroSchema = yup.object({
  tipoFiltro: yup.string().oneOf(['codigo', 'nome']).required(),
  inicial: yup
    .mixed()
    .nullable()
    .test('tipo-inicial', function(v) {
      const { tipoFiltro } = this.parent;
      if (validarTipo(v, tipoFiltro)) return true;
      return this.createError({ message: mensagemTipo(tipoFiltro) });
    }),
  final: yup
    .mixed()
    .nullable()
    .test('tipo-final', function(v) {
      const { tipoFiltro } = this.parent;
      if (validarTipo(v, tipoFiltro)) return true;
      return this.createError({ message: mensagemTipo(tipoFiltro) });
    })
    .test('range', function(v) {
      const { tipoFiltro, inicial } = this.parent;
      if (inicial === '' || inicial == null || v === '' || v == null) return true;
      if (tipoFiltro === 'codigo') {
        const ini = Number(inicial);
        const fim = Number(v);
        if (Number.isNaN(ini) || Number.isNaN(fim)) return true;
        if (ini <= fim) return true;
        return this.createError({ message: 'Código inicial deve ser ≤ código final' });
      }
      const cmp = String(inicial).localeCompare(String(v), 'pt-BR', { sensitivity: 'base' });
      if (cmp <= 0) return true;
      return this.createError({ message: 'Nome inicial deve ser ≤ nome final' });
    }),
});

export const filtroInicial = {
  tipoFiltro: 'codigo',
  inicial: '',
  final: '',
};
